// extracted by mini-css-extract-plugin
export default {"tableHeader":"TeacherPlanReport_tableHeader__L3RXO","groupBorder":"TeacherPlanReport_groupBorder__epoGG"};